import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link as RouteNavLink, useLocation } from "react-router-dom";
import { Col, Nav, NavItem, NavLink , Badge} from "shards-react";
import classNames from "classnames";
import useCurrentUser from "shared/hook/useCurrentUser";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";

const axios = require("axios").default;

const LinkMenu = styled.div`
  border-top: 1px solid #e1e5eb;
  padding: 25px 1.5625rem 0.9375rem;
  color: #b0b0b0;
  &:first-child {
    border-top: none;
  }
`;

const StyleBadge = styled(Badge)`
  background-color: #D90000 !important;
  padding: 6px !important;
  margin-left: 5px !important;
`;



const MenuBar = (props) => {
  const { show } = props;
  const pathname = useLocation().pathname;
  const { curruntUser } = useCurrentUser();
  const [userType, setUserType] = useState(0);
  const { token } = useToken();
  const [totalDocument, setTotalDocument] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (curruntUser) {
        setUserType(curruntUser.detail.userType);
    }
  }, [curruntUser]);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds => seconds + 1);
    }, 1000);
    if(seconds === 60){
      setSeconds(0)
    }
    return () => clearInterval(interval);

  }, [seconds]);
  
  useEffect(() => {
    if (token && seconds === 1) {
      var data = JSON.stringify({
        params: {
          questionnaireId: "",
        },
        show: 1,
        page: 1,
        orderBy: "questionnaireId",
        orderType: "desc",
      });
  
      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/questionnairelist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setTotalDocument(response.data.totalDocument)
        })
        .catch((error) => {
          console.log(error);  
        });
    }
  }, [seconds]);
  

  const classes = classNames(
    "main-sidebar",
    "px-0",
    "col-12",
    "pt-50",
    show && userType != 0 && userType != 2 && userType != 5 && "open"
  );
  return (
    <Col tag="aside" className={classes}>
      <div className="nav-wrapper">
        <Nav className="nav--no-borders flex-column">
          <LinkMenu>
            <small>เมนู</small>
          </LinkMenu>
          <NavItem>
            <NavLink tag={RouteNavLink} to="/">
              <span>หน้าหลัก</span>
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink tag={RouteNavLink} to="/manual" 
              active={pathname.includes("/manual")}>
              <span>คู่มือการใช้งาน</span>
            </NavLink>
          </NavItem>
          <LinkMenu>
            <small>ข้อมูล/ตัวชี้วัด</small>
          </LinkMenu>
          <NavItem>
            <NavLink
              tag={RouteNavLink}
              to="/powerbisetting/keyin"
              active={pathname.includes("/powerbisetting")}
            >
              <span>นำเข้าข้อมูลตัวชี้วัด</span>
              <div
                className="d-inline-block item-icon-wrapper"
                style={{ float: "right" }}
                dangerouslySetInnerHTML={{
                  __html: pathname.includes("/powerbisetting")
                    ? '<i class="material-icons">expand_more</i>'
                    : '<i class="material-icons">chevron_right</i>',
                }}
              />
            </NavLink>
            {pathname.includes("/powerbisetting") && (
              <Nav className="nav--no-borders flex-column">
                <NavItem>
                  <NavLink
                    tag={RouteNavLink}
                    to="/powerbisetting/keyin"
                    active={pathname.includes("/powerbisetting/keyin")}
                  >
                    <span style={{ paddingLeft: "20px" }}>
                      กรอกข้อมูลผ่านระบบ(Key-in)
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={RouteNavLink}
                    to="/powerbisetting/uploadfile"
                    active={pathname.includes("/powerbisetting/uploadfile")}
                  >
                    <span style={{ paddingLeft: "20px" }}>
                      อัพโหลดไฟล์ (Upload file)
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={RouteNavLink}
                    to="/powerbisetting/api"
                    active={pathname.includes("/powerbisetting/api")}
                  >
                    <span style={{ paddingLeft: "20px" }}>
                      อัพเดทข้อมูล ผ่าน API
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>
            )}
          </NavItem>
          <NavItem>
            <NavLink
              tag={RouteNavLink}
              to="/powerbilist"
              active={
                pathname.includes("/powerbilist") ||
                pathname.includes("/powerbidetail")
              }
            >
                {
                    userType == 1 || userType == 4 ?
                    <span>จัดการข้อมูลและอนุมัติเผยแพร่ข้อมูล</span> :
                    <span>จัดการข้อมูล</span>
                }
            </NavLink>
          </NavItem>

          {userType === 1 && (
            <>
              <LinkMenu>
                <small>Administrator</small>
              </LinkMenu>

              <NavItem>
                <NavLink
                  tag={RouteNavLink}
                  to="/administrator/users"
                  active={pathname.includes("/administrator/users")}
                >
                  <span>การจัดการผู้ใช้งาน</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={RouteNavLink}
                  to="/administrator/powerbi"
                  active={pathname.includes("/administrator/powerbi")}
                >
                  <span>จัดการคำอธิบายของข้อมูล/ตัวชี้วัด</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={RouteNavLink}
                  to="/administratorhome/banner"
                  active={pathname.includes("/administratorhome")}
                >
                  <span>จัดการหน้าหลัก</span>
                  <div
                    className="d-inline-block item-icon-wrapper"
                    style={{ float: "right" }}
                    dangerouslySetInnerHTML={{
                      __html: pathname.includes("/administratorhome")
                        ? '<i class="material-icons">expand_more</i>'
                        : '<i class="material-icons">chevron_right</i>',
                    }}
                  />
                </NavLink>
                {pathname.includes("/administratorhome") && (
                  <Nav className="nav--no-borders flex-column">
                    <NavItem>
                      <NavLink
                        tag={RouteNavLink}
                        to="/administratorhome/banner"
                        active={pathname.includes("/administratorhome/banner")}
                      >
                        <span style={{ paddingLeft: "20px" }}>
                          จัดการส่วน Banner
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag={RouteNavLink}
                        to="/administratorhome/contentmain"
                        active={pathname.includes("/administratorhome/content")}
                      >
                        <span style={{ paddingLeft: "20px" }}>
                          จัดการรายการแสดงมิติข้อมูล
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag={RouteNavLink}
                        to="/administratorhome/interesting"
                        active={pathname.includes(
                          "/administratorhome/interesting"
                        )}
                      >
                        <span style={{ paddingLeft: "20px" }}>
                          จัดการตัวชี้วัดที่น่าสนใจ
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag={RouteNavLink}
                        to="/administratorhome/wheadsetting"
                        active={pathname.includes(
                          "/administratorhome/wheadsetting"
                        )}
                      >
                        <span style={{ paddingLeft: "20px" }}>
                        จัดการกฎหมาย
                        </span>
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        tag={RouteNavLink}
                        to="/administratorhome/footersetting"
                        active={pathname.includes(
                          "/administratorhome/footersetting"
                        )}
                      >
                        <span style={{ paddingLeft: "20px" }}>
                        จัดการหน่วยงานเกี่ยวข้อง
                        </span>
                      </NavLink>
                    </NavItem>
                  </Nav>
                )}
              </NavItem>
              <NavItem>
                <NavLink
                  tag={RouteNavLink}
                  to="/administrator/inquiryform"
                  active={pathname.includes("/administrator/inquiryform")}
                >
                  <span>แบบสอบถามข้อมูล<StyleBadge theme="danger">{totalDocument}</StyleBadge></span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={RouteNavLink}
                  to="/administrator/email"
                  active={pathname.includes("/administrator/email")}
                >
                  <span>การแจ้งเตือน E-mail</span>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={RouteNavLink}
                  to="/administrator/report"
                  active={pathname.includes("/administrator/report")}
                >
                  <span>รายงานการใช้งานระบบ</span>
                </NavLink>
              </NavItem>
            </>
          )}
        </Nav>
      </div>
    </Col>
  );
};
export default MenuBar;
